/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {EmGroup} from '../models/em-group';
import {GroupType} from '../models/group-type';

import {GroupService} from '../services/group.service';
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from './simple-success-error-dialog-box/simple-success-error-dialog-box.component';

declare var $: any;

@Component({
  selector: 'app-add-to-group-dialog',
  templateUrl: './add-to-group-dialog.component.html'
})
export class AddToGroupDialogComponent implements OnInit {

    /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;
  
  @Output()
  confirmEvent = new EventEmitter<EmGroup>();
  
  mGroupType: GroupType = null;
  mGroups: EmGroup[] = [];
  mSelectedGroup: EmGroup = null;
  
  mObjectNames: string[] = [];
  
  constructor(
    private mRouter: Router,
    private mGroupService: GroupService
  ) {}


  ngOnInit(): void {
    
  }
  
  show(groupType: GroupType, objectNames: string[]): void {
    this.mGroupType = groupType;
    this.mObjectNames = objectNames;
    this.mSelectedGroup = null;
    this
      .mGroupService
      .getAllGroupsForGroupType(this.mGroupType)
      .then(
        result => {
          this.mGroups = result;
          this.mSelectedGroup = this.mGroups.length > 0? this.mGroups[0] : null;
          $("#add-to-group-dialog").modal("show");
        },
        error => this.handleError(error)
      );
  }
  
  hide(): void {
    $("#add-to-group-dialog").modal("hide");
  }
  
  confirm(): void {
    if (this.mSelectedGroup == null) {
      alert("A Group must be selected.");
    } else {
      this.confirmEvent.emit(this.mSelectedGroup);
      this.hide();
    }
  }
  
  
  
  
  
  handleError(error: any): void {
    console.error("AddToGroupDialogComponent.handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
        // Show the error in the SimpleSuccessErrorDialogComponent
        this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }

}
